import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import EmailBatchStatusTable from "@/components/emailBatchStatus/emailBatchStatusTable";

const EmailBatchStatusList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_email_batch_status_list">
      <EmailBatchStatusTable />
    </RestrictedPage>
  );
};

export default EmailBatchStatusList;
